module.exports = __webpack_public_path__ + "static/media/email-team.49a5abb2.jpg";